import {v4 as uuid} from "uuid";
import {NodeFileSearchControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import {ResourceType} from "models/ResourceType";

export class Audio {

    constructor(parentComponent, audioAdded, audioRemoved) {
        this.parentComponent = parentComponent;
        this.onAudioAdded = audioAdded;
        this.onAudioRemoved = audioRemoved;
        this.isAdded = false;
    }

    addAudio(node, audioUUID = null) {
        if (audioUUID == null) {
            audioUUID = uuid();
        }

        const audioFileControl = new NodeFileSearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getAudioFileKey(audioUUID),
            node,
            ResourceType.NodeAudio,
            false,
            "Audio file"
        );

        const removeAudioControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getAudioRemoveButtonKey(audioUUID),
            node,
            false,
            () => this.onRemoveAudioClick.bind(this, node, audioUUID, removeAudioControl, audioFileControl)
        );

        node
            .addControl(removeAudioControl)
            .addControl(audioFileControl)

        this.AudioAdded(node, audioUUID);
        node.update();
    }

    AudioAdded(node, addedAudioUUID) {
        node.audioId = addedAudioUUID;
        this.isAdded = true;
        this.onAudioAdded();
    }

    onRemoveAudioClick(node, audioUUID, removeAudioControl, audioFileControl) {
        this.removeAudio(node, audioUUID, removeAudioControl, audioFileControl)
            .then(r => {
                this.audioRemoved(node, audioUUID);
            });
    }

    async removeAudio(node, audioUUID, removeAudioControl, audioFileControl) {
        node.removeControl(removeAudioControl);
        node.removeControl(audioFileControl);

        node.update();

        delete node.data[SequenceComponentHelper.getAudioFileKey(audioUUID)];
    }

    async audioRemoved(node, removedAudioUUID) {
        node.audioId = null;
        this.isAdded = false;
        this.onAudioRemoved();
    }
}